import apiClient from './config';
import { Client, Suscripcion } from "../../types/index";
import { ClienteSinBeneficiario } from '../../types/clientes';

interface ClientSubscriptionData {
    client: Partial<Client>;
    subscription: Partial<Suscripcion>;
}

interface ClientSubscriptionResponse {
    message: string;
    client: Client;
    subscription: Suscripcion;
}

interface DeleteClientSubscriptionResponse {
    message: string;
    plazasDesactivadas: number;
    eventosActualizados: number;
    pagosEliminados?: number;
    contratoArchivado?: boolean;
    contratoId?: string;
    updatedPayer?: {
        subscription_id: string;
        client_id: string;
    };
}

export const createClientAndSubscription = async (
    data: ClientSubscriptionData
): Promise<ClientSubscriptionResponse> => {
    const response = await apiClient.post('/client-subscription', data);
    return response.data;
};

export const getAllClientsAndSubscriptions = async (activo?: boolean): Promise<Client[]> => {
    const query = activo !== undefined ? `?activo=${activo}` : '';
    const response = await apiClient.get(`/client-subscriptions${query}`);
    return response.data;
};

export const getClientAndSubscriptionById = async (id: string): Promise<Client> => {
    const response = await apiClient.get(`/clients-subscriptions/${id}`);
    return response.data;
};

export const fetchClientesSinBeneficiario = async (): Promise<ClienteSinBeneficiario[]> => {
    const response = await apiClient.get('/client-subscriptions/independent-clients');
    return response.data;
};


/**
 * Realiza el borrado lógico de un cliente y su suscripción
 * @param clientId ID del cliente a borrar
 * @param subscriptionId ID de la suscripción a borrar (opcional)
 * @param updatedBy Usuario que realiza la operación
 * @param deleteOpenPayments Si se deben eliminar los pagos abiertos (para clientes de otros pagos)
 * @returns Respuesta con detalles de la operación
 */
export const deleteClientAndSubscription = async (
    clientId: string,
    subscriptionId?: string,
    updatedBy?: string,
    deleteOpenPayments?: boolean
): Promise<DeleteClientSubscriptionResponse> => {
    let url = `/client-subscriptions/${clientId}${subscriptionId ? `/${subscriptionId}` : ''}`;
    
    // Agregar parámetro de query si se debe eliminar pagos abiertos
    if (deleteOpenPayments) {
        url += '?deleteOpenPayments=true';
    }
    
    const response = await apiClient.delete(url, {
        data: { updatedBy: updatedBy || 'system' }
    });
    return response.data;
};


/**
 * Restaura un cliente y su suscripción (cambia activo: true)
 * @param clientId ID del cliente a restaurar
 * @param subscriptionId ID de la suscripción a restaurar (opcional)
 * @returns Respuesta con el cliente restaurado
 */
export const restoreClientAndSubscription = async (
    clientId: string,
    subscriptionId?: string | null
): Promise<{ message: string; clientId: string }> => {
    const response = await apiClient.put('/client-subscriptions/restore', {
        clientId,
        subscriptionId
    });
    return response.data;
};